var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "table table-sm table-hover table-striped" }, [
      _c(
        "tbody",
        [
          _vm._l(_vm.$AllDivisions, function (div) {
            return div.is_active && div.id !== 7
              ? _c("tr", [
                  _c("td", [
                    _vm._v(
                      "\n        " +
                        _vm._s(div?.user?.name || "Не определен") +
                        "\n        (" +
                        _vm._s(div?.cities[0]?.city?.name || "не указан") +
                        ")\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "balance_td" },
                    [
                      _vm.loadingBalance[div.id]
                        ? [_c("pulse-loader", { attrs: { size: "10px" } })]
                        : _vm._l(
                            _vm.balanceReport[div.id]?.balance ?? [],
                            function (bData, currId) {
                              return +bData.amount
                                ? _c("p", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$AllCurrencies[currId].currency
                                        ) +
                                        ": "
                                    ),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          Math.round(
                                            bData.amount
                                          ).toLocaleString("ru-RU")
                                        )
                                      ),
                                    ]),
                                  ])
                                : _vm._e()
                            }
                          ),
                    ],
                    2
                  ),
                ])
              : _vm._e()
          }),
          _vm._v(" "),
          _c("tr", { staticClass: "total_tr" }, [
            _c("td", { staticClass: "text-right" }, [_vm._v("ИТОГО")]),
            _vm._v(" "),
            _c("td", { staticClass: "text-left" }, [
              _vm._v("EUR: " + _vm._s(_vm.printDivBalanceSum())),
            ]),
          ]),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }